import { getJirItemUrl } from "../../api/api";
import { navigateTo } from "../../Navigator";
import { Link, useNavigate } from "react-router-dom";

const CardTitle = ({ task, title }) => {
  const navigate = useNavigate();
  return (
    <Link
      className={"flex hover:text-blue-800"}
      to={`/workspaces/${task.get("projectId")}/items/${task.get("id")}?type=${task.get(
        "type"
      )}&view=BOARD`}
      onClick={() => {
        const appUrl = `/workspaces/${task.get("projectId")}/items/${task.get(
          "id"
        )}?type=${task.get("type")}&view=BOARD`;
        const jiraUrl = getJirItemUrl({
          workspaceId: task.get("projectId"),
          itemId: task.get("id"),
          type: task.get("type"),
          view: "BOARD",
        });
        navigateTo({
          jiraUrlParams: { relativeUrl: jiraUrl },
          appUrl,
          navigate,
        });
      }}
    >
      <div title={title} className={"w-48 font-semibold truncate"}>
        {title}
      </div>
    </Link>
  );
};

export default CardTitle;
